module.exports = __webpack_public_path__ + "static/media/video-time.92fa586c.svg";